import PricingBaseController from "~/controllers_back/checkout/pricing-base_controller"

export default class extends PricingBaseController {
  static targets = [
    ...PricingBaseController.targets,
    "dropdownDisplay", "selectedPlanName", "selectedPlanCredits",
    "selectedPlanPrice", "recommendedTag", "yearlyAlert",
    "yearlySavings", "monthlyAlert",
    "monthlyCrossedPrice",
    "selectedPlanMonthlyCrossedPrice",
    "totalDisplayContainer",
    "selectedPlanTotalContainer",
    "selectedPlanTotal"
  ]

  static values = {
    ...PricingBaseController.values,
    yearlySavings: Object,
    recommendedLevel: Number
  }

  connect() {
    super.connect()
    this.updateDropdownDisplay()
  }

  updatePrices() {
    super.updatePrices()

    const billingCycle = this.getSelectedBillingCycle()
    const level = this.getSelectedPlanLevel()

    // Update yearly savings
    this.updateYearlySavings(level)

    // Update alert visibility
    this.updateAlertVisibility(billingCycle)

    // Update dropdown display
    this.updateDropdownDisplay()
  }

  switchToYearly(event) {
    event.preventDefault()
    this.switchToBillingCycle('yearly')
  }

  switchToMonthly(event) {
    event.preventDefault()
    this.switchToBillingCycle('monthly')
  }

  selectPlanFromDropdown(event) {
    event.preventDefault()
    event.stopPropagation()

    const level = parseInt(event.currentTarget.dataset.level)
    const radioInput = event.currentTarget.querySelector('input[type="radio"]')

    // Don't do anything if this is the current plan (disabled)
    if (radioInput && radioInput.disabled) {
      return
    }

    // Select the plan
    this.selectPlan(level)

    // Close the dropdown
    this.closeDropdown()

    // Update the display
    this.updateDropdownDisplay()
  }

  togglePlanDetails(event) {
    event.preventDefault()
    event.stopPropagation()

    const level = parseInt(event.currentTarget.dataset.level)
    const isFromDropdown = event.currentTarget.closest('.dropdown')

    // Don't select the plan if clicking from dropdown - just show details
    if (!isFromDropdown) {
      this.selectPlan(level)
    }

    super.togglePlanDetails(event)
  }

  updateYearlySavings(level) {
    const savings = this.yearlySavingsValue[level]
    this.yearlySavingsTarget.textContent = savings.formatted
  }

  updateAlertVisibility(billingCycle) {
    if (this.hasYearlyAlertTarget) {
      this.yearlyAlertTarget.style.display = billingCycle === "monthly" ? "block" : "none"
    }
    if (this.hasMonthlyAlertTarget) {
      this.monthlyAlertTarget.style.display = billingCycle === "yearly" ? "block" : "none"
    }
  }

  updatePriceDisplay(billingCycle, level) {
    if (this.hasMonthlyCrossedPriceTarget) {
      this.monthlyCrossedPriceTargets.forEach(el => {
        el.style.display = billingCycle === "yearly" ? "inline" : "none"
      })
    }
    if (this.hasTotalDisplayContainerTarget) {
      this.totalDisplayContainerTargets.forEach(el => {
        el.style.display = billingCycle === "yearly" ? "block" : "none"
      });
    }
    super.updatePriceDisplay(billingCycle, level)
  }

  updateDropdownDisplay() {
    const level = this.selectedLevelValue
    const billingCycle = this.selectedBillingValue
    const yearlyPrices = this.yearlyPricesValue
    const monthlyPrices = this.monthlyPricesValue

    const pricesValue = billingCycle === "yearly" ? yearlyPrices : monthlyPrices
    this.selectedPlanNameTarget.textContent = pricesValue[level]?.name || ""
    this.selectedPlanCreditsTarget.textContent = pricesValue[level]?.credits || ""

    if (this.hasSelectedPlanMonthlyCrossedPriceTarget) {
      this.selectedPlanMonthlyCrossedPriceTarget.textContent = monthlyPrices[level]?.price || ""
      this.selectedPlanMonthlyCrossedPriceTarget.style.display = billingCycle === "yearly" ? "inline" : "none"
    }

    if (this.hasSelectedPlanPriceTarget) {
      const pricesValue = billingCycle === "yearly" ? yearlyPrices : monthlyPrices
      this.selectedPlanPriceTarget.textContent = pricesValue[level]?.price || ""
    }

    if (this.hasSelectedPlanTotalContainerTarget) {
      this.selectedPlanTotalContainerTarget.style.display = billingCycle === "yearly" ? "block" : "none"
      if (this.hasSelectedPlanTotalTarget) {
        this.selectedPlanTotalTarget.textContent = yearlyPrices[level]?.total || ""
      }
    }

    // Show/hide recommended tag
    if (this.hasRecommendedTagTarget) {
      this.recommendedTagTarget.style.display = level === this.recommendedLevelValue ? "inline-flex" : "none"
    }

    // Update checkmarks in dropdown
    this.updateDropdownCheckmarks(level)
  }

  updateDropdownCheckmarks(selectedLevel) {
    const dropdown = this.element.querySelector('.plan-selection__dropdown')
    if (!dropdown) return

    dropdown.querySelectorAll('.plan-selection-option').forEach(option => {
      const optionLevel = parseInt(option.dataset.level)
      const icon = option.querySelector('.plan-selection-option__icon')

      if (optionLevel === selectedLevel) {
        option.classList.add('is-selected')
        if (icon) icon.className = 'plan-selection-option__icon far fa-check-circle blue'
      } else {
        option.classList.remove('is-selected')
        if (icon) icon.className = 'plan-selection-option__icon'
      }
    })
  }

  closeDropdown() {
    const dropdown = this.element.querySelector('#plan-dropdown')
    if (!dropdown) return

    const dropdownInstance = bootstrap.Dropdown.getInstance(
      dropdown.querySelector('[data-bs-toggle="dropdown"]')
    )

    if (dropdownInstance) {
      dropdownInstance.hide()
    }
  }
}
